export const AVAILABLE_PLANS = {
  BRL: [
    {
      id: 1,
      name: 'Starter',
      price: 0,
      users: 1,
      interactionz: 100,
      priceForExceededUsers: 250,
      priceForExceededInteratcionz: 2.50,
      activationPrice: 649,
    },
    {
      id: 2,
      name: 'Specialist',
      price: 600,
      users: 10,
      interactionz: 500,
      priceForExceededUsers: 150,
      priceForExceededInteratcionz: 1.32,
      activationPrice: 649,
    },
    {
      id: 3,
      name: 'Expert',
      price: 1800,
      users: 30,
      interactionz: 2000,
      priceForExceededUsers: 100,
      priceForExceededInteratcionz: 0.99,
      activationPrice: 1999,
    },
    {
      id: 4,
      name: 'Professional',
      price: 3900,
      users: 50,
      interactionz: 5000,
      priceForExceededUsers: 100,
      priceForExceededInteratcionz: 0.86,
      activationPrice: 3999,
    },
    {
      id: 5,
      name: 'Enterprise',
      price: 0,
      users: 0,
      interactionz: 0,
      priceForExceededUsers: 0,
      priceForExceededInteratcionz: 0,
      activationPrice: 0,
    },
  ],
  USD: [
    {
      id: 1,
      name: 'Starter',
      price: 0,
      users: 1,
      interactionz: 100,
      priceForExceededUsers: 53,
      priceForExceededInteratcionz: 1,
      activationPrice: 137,
    },
    {
      id: 2,
      name: 'Specialist',
      price: 130,
      users: 10,
      interactionz: 500,
      priceForExceededUsers: 32,
      priceForExceededInteratcionz: 0.28,
      activationPrice: 137,
    },
    {
      id: 3,
      name: 'Expert',
      price: 390,
      users: 30,
      interactionz: 2000,
      priceForExceededUsers: 22,
      priceForExceededInteratcionz: 0.21,
      activationPrice: 421,
    },
    {
      id: 4,
      name: 'Professional',
      price: 845,
      users: 50,
      interactionz: 5000,
      priceForExceededUsers: 22,
      priceForExceededInteratcionz: 0.19,
      activationPrice: 842,
    },
    {
      id: 5,
      name: 'Enterprise',
      price: 0,
      users: 0,
      interactionz: 0,
      priceForExceededUsers: 0,
      priceForExceededInteratcionz: 0,
      activationPrice: 0,
    },
  ],
  MXN: [
    {
      id: 1,
      name: 'Starter',
      price: 0,
      users: 1,
      interactionz: 100,
      priceForExceededUsers: 917,
      priceForExceededInteratcionz: 18,
      activationPrice: 2369,
    },
    {
      id: 2,
      name: 'Specialist',
      price: 2200,
      users: 10,
      interactionz: 500,
      priceForExceededUsers: 554,
      priceForExceededInteratcionz: 4.80,
      activationPrice: 2369,
    },
    {
      id: 3,
      name: 'Expert',
      price: 6600,
      users: 30,
      interactionz: 2000,
      priceForExceededUsers: 381,
      priceForExceededInteratcionz: 3.60,
      activationPrice: 7279,
    },
    {
      id: 4,
      name: 'Professional',
      price: 14300,
      users: 50,
      interactionz: 5000,
      priceForExceededUsers: 381,
      priceForExceededInteratcionz: 3.20,
      activationPrice: 14557,
    },
    {
      id: 5,
      name: 'Enterprise',
      price: 0,
      users: 0,
      interactionz: 0,
      priceForExceededUsers: 0,
      priceForExceededInteratcionz: 0,
      activationPrice: 0,
    },
  ],
};

export const AVAILABLE_CHANNELS = {
  BRL: [
    {
      id: 1,
      price: 100,
      sms: 1000,
      whatsapp: 182,
      whatsappUser: 333,
      email: 25000,
      smsUnitPrice: 0.100,
      whatsappBusinessUnitPrice: 0.550,
      whatsappUserUnitPrice: 0.300,
      emailUnitPrice: 0.0040,
    },
    {
      id: 2,
      price: 250,
      sms: 2941,
      whatsapp: 472,
      whatsappUser: 893,
      email: 71429,
      smsUnitPrice: 0.085,
      whatsappBusinessUnitPrice: 0.530,
      whatsappUserUnitPrice: 0.280,
      emailUnitPrice: 0.0035,
    },
    {
      id: 3,
      price: 500,
      sms: 6250,
      whatsapp: 980,
      whatsappUser: 1923,
      email: 166667,
      smsUnitPrice: 0.080,
      whatsappBusinessUnitPrice: 0.510,
      whatsappUserUnitPrice: 0.260,
      emailUnitPrice: 0.0030,
    },
    {
      id: 4,
      price: 1000,
      sms: 13333,
      whatsapp: 2041,
      whatsappUser: 4167,
      email: 400000,
      smsUnitPrice: 0.075,
      whatsappBusinessUnitPrice: 0.490,
      whatsappUserUnitPrice: 0.240,
      emailUnitPrice: 0.0025,
    },
    {
      id: 5,
      price: 2000,
      sms: 28571,
      whatsapp: 4255,
      whatsappUser: 9091,
      email: 1000000,
      smsUnitPrice: 0.070,
      whatsappBusinessUnitPrice: 0.470,
      whatsappUserUnitPrice: 0.220,
      emailUnitPrice: 0.0020,
    },
    {
      id: 6,
      price: 5000,
      sms: 76923,
      whatsapp: 10870,
      whatsappUser: 23810,
      email: 2631579,
      smsUnitPrice: 0.0650,
      whatsappBusinessUnitPrice: 0.4600,
      whatsappUserUnitPrice: 0.2100,
      emailUnitPrice: 0.0019,
    },
    {
      id: 7,
      price: 10000,
      sms: 166667,
      whatsapp: 22222,
      whatsappUser: 50000,
      email: 5555556,
      smsUnitPrice: 0.0600,
      whatsappBusinessUnitPrice: 0.4500,
      whatsappUserUnitPrice: 0.2000,
      emailUnitPrice: 0.0018,
    },
    {
      id: 8,
      price: 20000,
      sms: 350877,
      whatsapp: 44444,
      whatsappUser: 105263,
      email: 11428571,
      smsUnitPrice: 0.0570,
      whatsappBusinessUnitPrice: 0.4500,
      whatsappUserUnitPrice: 0.1900,
      emailUnitPrice: 0.0018,
    },
    {
      id: 9,
      price: 30000,
      sms: 545455,
      whatsapp: 68182,
      whatsappUser: 166667,
      email: 17647059,
      smsUnitPrice: 0.0550,
      whatsappBusinessUnitPrice: 0.4400,
      whatsappUserUnitPrice: 0.1800,
      emailUnitPrice: 0.0017,
    },
    {
      id: 10,
      price: 40000,
      sms: 754717,
      whatsapp: 90909,
      whatsappUser: 235294,
      email: 24242424,
      smsUnitPrice: 0.0530,
      whatsappBusinessUnitPrice: 0.4400,
      whatsappUserUnitPrice: 0.1700,
      emailUnitPrice: 0.0017,
    },
    {
      id: 11,
      price: 50000,
      sms: 961538,
      whatsapp: 116279,
      whatsappUser: 312500,
      email: 31250000,
      smsUnitPrice: 0.0520,
      whatsappBusinessUnitPrice: 0.4300,
      whatsappUserUnitPrice: 0.1600,
      emailUnitPrice: 0.0016,
    },
  ],
  USD: [
    // US - price 20
    {
      id: 1,
      price: 20,
      sms: 1087,
      whatsapp: 362,
      whatsappUser: 1080,
      email: 25000,
      smsUnitPrice: 0.01840,
      whatsappBusinessUnitPrice: 0.05520,
      whatsappUserUnitPrice: 0.01853,
      emailUnitPrice: 0.00080,
    },
    // US - price 50
    {
      id: 2,
      price: 50,
      sms: 3205,
      whatsapp: 1066,
      whatsappUser: 2892,
      email: 66667,
      smsUnitPrice: 0.01560,
      whatsappBusinessUnitPrice: 0.04690,
      whatsappUserUnitPrice: 0.01729,
      emailUnitPrice: 0.00075,
    },
    // US - price 100
    {
      id: 3,
      price: 100,
      sms: 6803,
      whatsapp: 2262,
      whatsappUser: 6228,
      email: 142857,
      smsUnitPrice: 0.01470,
      whatsappBusinessUnitPrice: 0.04420,
      whatsappUserUnitPrice: 0.01606,
      emailUnitPrice: 0.00070,
    },
    // US - price 200
    {
      id: 4,
      price: 200,
      sms: 14493,
      whatsapp: 4831,
      whatsappUser: 13494,
      email: 307692,
      smsUnitPrice: 0.01380,
      whatsappBusinessUnitPrice: 0.04140,
      whatsappUserUnitPrice: 0.01482,
      emailUnitPrice: 0.00065,
    },
    // US - price 400
    {
      id: 5,
      price: 400,
      sms: 31008,
      whatsapp: 10363,
      whatsappUser: 29442,
      email: 666667,
      smsUnitPrice: 0.01290,
      whatsappBusinessUnitPrice: 0.03860,
      whatsappUserUnitPrice: 0.01359,
      emailUnitPrice: 0.00060,
    },
    // US - price 1000
    {
      id: 6,
      price: 1000,
      sms: 84034,
      whatsapp: 27855,
      whatsappUser: 77110,
      email: 1818182,
      smsUnitPrice: 0.01190,
      whatsappBusinessUnitPrice: 0.03590,
      whatsappUserUnitPrice: 0.01297,
      emailUnitPrice: 0.00055,
    },
    // US - price 2000
    {
      id: 7,
      price: 2000,
      sms: 181818,
      whatsapp: 60423,
      whatsappUser: 161932,
      email: 4000000,
      smsUnitPrice: 0.01100,
      whatsappBusinessUnitPrice: 0.03310,
      whatsappUserUnitPrice: 0.01235,
      emailUnitPrice: 0.00050,
    },
    // US - price 4000
    {
      id: 8,
      price: 4000,
      sms: 396040,
      whatsapp: 131579,
      whatsappUser: 323864,
      email: 8888889,
      smsUnitPrice: 0.01010,
      whatsappBusinessUnitPrice: 0.03040,
      whatsappUserUnitPrice: 0.01235,
      emailUnitPrice: 0.00045,
    },
    // US - price 6000
    {
      id: 9,
      price: 6000,
      sms: 606061,
      whatsapp: 202020,
      whatsappUser: 485795,
      email: 15000000,
      smsUnitPrice: 0.00990,
      whatsappBusinessUnitPrice: 0.02970,
      whatsappUserUnitPrice: 0.01235,
      emailUnitPrice: 0.00040,
    },
    // US - price 8000
    {
      id: 10,
      price: 8000,
      sms: 833333,
      whatsapp: 275862,
      whatsappUser: 647727,
      email: 22857143,
      smsUnitPrice: 0.00960,
      whatsappBusinessUnitPrice: 0.02900,
      whatsappUserUnitPrice: 0.01235,
      emailUnitPrice: 0.00035,
    },
    // US - price 10000
    {
      id: 11,
      price: 10000,
      sms: 1052632,
      whatsapp: 348432,
      whatsappUser: 809659,
      email: 33333333,
      smsUnitPrice: 0.00950,
      whatsappBusinessUnitPrice: 0.02870,
      whatsappUserUnitPrice: 0.01235,
      emailUnitPrice: 0.00030,
    },
  ],
  MXN: [
    // mexico - price 400
    {
      id: 1,
      price: 400,
      sms: 919,
      whatsapp: 187,
      whatsappUser: 1085,
      email: 27397,
      smsUnitPrice: 0.4352,
      whatsappBusinessUnitPrice: 2.1389,
      whatsappUserUnitPrice: 0.3685,
      emailUnitPrice: 0.0146,
    },
    // mexico - price 1000
    {
      id: 2,
      price: 1000,
      sms: 2703,
      whatsapp: 550,
      whatsappUser: 2908,
      email: 78740,
      smsUnitPrice: 0.3700,
      whatsappBusinessUnitPrice: 1.8180,
      whatsappUserUnitPrice: 0.3439,
      emailUnitPrice: 0.0127,
    },
    // mexico - price 2000
    {
      id: 3,
      price: 2000,
      sms: 5744,
      whatsapp: 1169,
      whatsappUser: 6262,
      email: 183486,
      smsUnitPrice: 0.3482,
      whatsappBusinessUnitPrice: 1.7111,
      whatsappUserUnitPrice: 0.3194,
      emailUnitPrice: 0.0109,
    },
    // mexico - price 4000
    {
      id: 4,
      price: 4000,
      sms: 12255,
      whatsapp: 2494,
      whatsappUser: 13569,
      email: 439560,
      smsUnitPrice: 0.3264,
      whatsappBusinessUnitPrice: 1.6041,
      whatsappUserUnitPrice: 0.2948,
      emailUnitPrice: 0.0091,
    },
    // mexico - price 8000
    {
      id: 5,
      price: 8000,
      sms: 26255,
      whatsapp: 5343,
      whatsappUser: 29604,
      email: 1095890,
      smsUnitPrice: 0.3047,
      whatsappBusinessUnitPrice: 1.4972,
      whatsappUserUnitPrice: 0.2702,
      emailUnitPrice: 0.0073,
    },
    // mexico - price 20000
    {
      id: 6,
      price: 20000,
      sms: 70696,
      whatsapp: 14385,
      whatsappUser: 77536,
      email: 2898551,
      smsUnitPrice: 0.2829,
      whatsappBusinessUnitPrice: 1.3903,
      whatsappUserUnitPrice: 0.2579,
      emailUnitPrice: 0.0069,
    },
    // mexico - price 40000
    {
      id: 7,
      price: 40000,
      sms: 153198,
      whatsapp: 31170,
      whatsappUser: 162825,
      email: 6153846,
      smsUnitPrice: 0.2611,
      whatsappBusinessUnitPrice: 1.2833,
      whatsappUserUnitPrice: 0.2457,
      emailUnitPrice: 0.0065,
    },
    // mexico - price 80000
    {
      id: 8,
      price: 80000,
      sms: 334169,
      whatsapp: 68004,
      whatsappUser: 325649,
      email: 12698413,
      smsUnitPrice: 0.2394,
      whatsappBusinessUnitPrice: 1.1764,
      whatsappUserUnitPrice: 0.2457,
      emailUnitPrice: 0.0063,
    },
    // mexico - price 120000
    {
      id: 9,
      price: 120000,
      sms: 512601,
      whatsapp: 104321,
      whatsappUser: 488474,
      email: 19354839,
      smsUnitPrice: 0.2341,
      whatsappBusinessUnitPrice: 1.1503,
      whatsappUserUnitPrice: 0.2457,
      emailUnitPrice: 0.0062,
    },
    // mexico - price 160000
    {
      id: 10,
      price: 160000,
      sms: 700525,
      whatsapp: 142577,
      whatsappUser: 651298,
      email: 26229508,
      smsUnitPrice: 0.2284,
      whatsappBusinessUnitPrice: 1.1222,
      whatsappUserUnitPrice: 0.2457,
      emailUnitPrice: 0.0061,
    },
    // mexico - price 200000
    {
      id: 11,
      price: 200000,
      sms: 883783,
      whatsapp: 179824,
      whatsappUser: 814123,
      email: 33333333,
      smsUnitPrice: 0.2263,
      whatsappBusinessUnitPrice: 1.1122,
      whatsappUserUnitPrice: 0.2457,
      emailUnitPrice: 0.0060,
    },
  ],
};

export const PLANS_CHANNELS_COMBINATIONS = [

  // STARTER + CHANNEL 1
  {
    planId: '7554c732-3781-4948-a450-27a3e7129de8',
    softwarePlanId: 1,
    channelPlanId: 1,
  },

  // STARTER + CHANNEL 2
  {
    planId: '260e2332-7a72-4c32-9d36-fdfa8a1e5690',
    softwarePlanId: 1,
    channelPlanId: 2,
  },

  // STARTER + CHANNEL 3
  {
    planId: 'a99dd8bb-70d5-4308-94f2-47e3f6bb5b0a',
    softwarePlanId: 1,
    channelPlanId: 3,
  },

  // STARTER + CHANNEL 4
  {
    planId: '14f1811a-6aed-486e-a72b-55fdae39172e',
    softwarePlanId: 1,
    channelPlanId: 4,
  },

  // STARTER + CHANNEL 5
  {
    planId: 'a6aaff97-f4c6-40fc-bc5e-b7c31956875d',
    softwarePlanId: 1,
    channelPlanId: 5,
  },

  // STARTER + CHANNEL 6
  {
    planId: '14ea7a22-55ca-425f-ba31-133d79def6a8',
    softwarePlanId: 1,
    channelPlanId: 6,
  },

  // STARTER + CHANNEL 7
  {
    planId: '0079d5fd-5b99-4aad-ab1b-4bd9d482fed1',
    softwarePlanId: 1,
    channelPlanId: 7,
  },

  // STARTER + CHANNEL 8
  {
    planId: 'be69c0aa-6990-405e-8af6-433f9a70584b',
    softwarePlanId: 1,
    channelPlanId: 8,
  },

  // STARTER + CHANNEL 9
  {
    planId: '1beb5d90-8882-4720-9e1a-b3c4c946fc4e',
    softwarePlanId: 1,
    channelPlanId: 9,
  },

  // STARTER + CHANNEL 10
  {
    planId: 'b8f8c57e-47b4-4c55-b022-be6645752caf',
    softwarePlanId: 1,
    channelPlanId: 10,
  },

  // STARTER + CHANNEL 11
  {
    planId: '348c6d8c-2b9a-4502-8d6b-59ff1e96ec22',
    softwarePlanId: 1,
    channelPlanId: 11,
  },

  // ----------------------------------------------------------

  // SPECIALIST + CHANNEL 1
  {
    planId: 'edf36a91-4285-453f-977c-2ca85323daf2',
    softwarePlanId: 2,
    channelPlanId: 1,
  },

  // SPECIALIST + CHANNEL 2
  {
    planId: 'ee892255-2d06-4e32-8674-908c0b14548e',
    softwarePlanId: 2,
    channelPlanId: 2,
  },

  // SPECIALIST + CHANNEL 3
  {
    planId: 'fae69cb2-db0d-4920-a35d-be791a1b2087',
    softwarePlanId: 2,
    channelPlanId: 3,
  },

  // SPECIALIST + CHANNEL 4
  {
    planId: 'cdd60a6d-4693-4236-9443-7d0d262760f5',
    softwarePlanId: 2,
    channelPlanId: 4,
  },

  // SPECIALIST + CHANNEL 5
  {
    planId: '6e9e915e-0188-48a1-9cfa-cfc35ea0d022',
    softwarePlanId: 2,
    channelPlanId: 5,
  },

  // SPECIALIST + CHANNEL 6
  {
    planId: 'ab34975f-76e4-4c85-bf5a-0814c1c88bf2',
    softwarePlanId: 2,
    channelPlanId: 6,
  },

  // SPECIALIST + CHANNEL 7
  {
    planId: 'c8ffbfa1-b696-401d-a00e-1c088b86c6af',
    softwarePlanId: 2,
    channelPlanId: 7,
  },

  // SPECIALIST + CHANNEL 8
  {
    planId: '5ab11877-8b88-4957-a01c-cb2822a935a8',
    softwarePlanId: 2,
    channelPlanId: 8,
  },

  // SPECIALIST + CHANNEL 9
  {
    planId: '35ec0951-344d-4dff-8875-46940f6a0a31',
    softwarePlanId: 2,
    channelPlanId: 9,
  },

  // SPECIALIST + CHANNEL 10
  {
    planId: '54592f69-e258-4bfc-997a-15b874021ca1',
    softwarePlanId: 2,
    channelPlanId: 10,
  },

  // SPECIALIST + CHANNEL 11
  {
    planId: 'a104d5c0-6da1-4ec2-87ae-21ef874e3a77',
    softwarePlanId: 2,
    channelPlanId: 11,
  },

  // -------------------------------------------------------------

  // EXPERT + CHANNEL 1
  {
    planId: '6c1554de-1737-4516-9526-3835b36a73dd',
    softwarePlanId: 3,
    channelPlanId: 1,
  },

  // EXPERT + CHANNEL 2
  {
    planId: '3cb8e2b3-c931-403f-b87e-7c811b8f5264',
    softwarePlanId: 3,
    channelPlanId: 2,
  },

  // EXPERT + CHANNEL 3
  {
    planId: 'd2386d37-1d4f-4eef-a8e4-5ef48b4eb8a3',
    softwarePlanId: 3,
    channelPlanId: 3,
  },

  // EXPERT + CHANNEL 4
  {
    planId: 'f35db249-6019-48b5-bc45-30095dc7c4ba',
    softwarePlanId: 3,
    channelPlanId: 4,
  },

  // EXPERT + CHANNEL 5
  {
    planId: 'bb8f39b7-70a4-436a-b077-7fbdde8d0323',
    softwarePlanId: 3,
    channelPlanId: 5,
  },

  // EXPERT + CHANNEL 6
  {
    planId: '3f627906-d9dd-4a91-84d4-1f56671dd6da',
    softwarePlanId: 3,
    channelPlanId: 6,
  },

  // EXPERT + CHANNEL 7
  {
    planId: 'dda80899-cc3e-4379-9333-26d04d760ccd',
    softwarePlanId: 3,
    channelPlanId: 7,
  },

  // EXPERT + CHANNEL 8
  {
    planId: 'ebe1bdde-28fc-42e0-8102-17af109ecba9',
    softwarePlanId: 3,
    channelPlanId: 8,
  },

  // EXPERT + CHANNEL 9
  {
    planId: '6b607ffe-e871-4add-bb3b-6df3faf131df',
    softwarePlanId: 3,
    channelPlanId: 9,
  },

  // EXPERT + CHANNEL 10
  {
    planId: '16189a63-95f1-4896-b9fe-d8bd8ff68d1a',
    softwarePlanId: 3,
    channelPlanId: 10,
  },

  // EXPERT + CHANNEL 11
  {
    planId: 'eed0e2f1-2fb7-479a-9b64-32026dd77815',
    softwarePlanId: 3,
    channelPlanId: 11,
  },

  // ----------------------------------------------------------

  // PROFESSIONAL + CHANNEL 1
  {
    planId: 'd0329c3f-ed97-4412-a612-4cf62cb4e344',
    softwarePlanId: 4,
    channelPlanId: 1,
  },

  // PROFESSIONAL + CHANNEL 2
  {
    planId: '7bd6d557-b2ea-4e66-ba9c-f60dd3b55db5',
    softwarePlanId: 4,
    channelPlanId: 2,
  },

  // PROFESSIONAL + CHANNEL 3
  {
    planId: '722fab72-5ae2-461e-98ef-184a4b0804b1',
    softwarePlanId: 4,
    channelPlanId: 3,
  },

  // PROFESSIONAL + CHANNEL 4
  {
    planId: 'df240706-a512-4aae-af9a-0d13da82bc2e',
    softwarePlanId: 4,
    channelPlanId: 4,
  },

  // PROFESSIONAL + CHANNEL 5
  {
    planId: '5551b8b6-e337-4419-905c-b730fa6c4d66',
    softwarePlanId: 4,
    channelPlanId: 5,
  },

  // PROFESSIONAL + CHANNEL 6
  {
    planId: '334667c5-5186-4112-8f46-5fd5a5bf1ebb',
    softwarePlanId: 4,
    channelPlanId: 6,
  },

  // PROFESSIONAL + CHANNEL 7
  {
    planId: 'b0161c72-be5f-4fc5-a516-f52d1ad46c31',
    softwarePlanId: 4,
    channelPlanId: 7,
  },

  // PROFESSIONAL + CHANNEL 8
  {
    planId: '502b1234-bde1-4302-ae75-79f30f50e1e7',
    softwarePlanId: 4,
    channelPlanId: 8,
  },

  // PROFESSIONAL + CHANNEL 9
  {
    planId: 'e6892d9d-b50e-4aac-aa03-1b9f702648ba',
    softwarePlanId: 4,
    channelPlanId: 9,
  },

  // PROFESSIONAL + CHANNEL 10
  {
    planId: '6df0045a-9353-484f-b699-55dba05fcf29',
    softwarePlanId: 4,
    channelPlanId: 10,
  },

  // PROFESSIONAL + CHANNEL 11
  {
    planId: '939e25cd-6451-42ea-88fb-dc08f2b4cc37',
    softwarePlanId: 4,
    channelPlanId: 11,
  },
];
